import { UNASSIGNED_USER_ID } from '@atlassian/jira-software-filters/src/common/constants.tsx';
import type { Person } from '../../model/types.tsx';

export const HEADER_DROPPABLE_ID_PREFIX = 'HEADER-DROP-' as const;
export const CARD_LIST_DROPPABLE_TYPE = 'CARD' as const;
export const CARD_GROUP_DROPPABLE_TYPE = 'CARD-GROUP' as const;
export const TRANSITION_ZONE_DROPPABLE_TYPE = 'TRANSITION-ZONE' as const;

export const UNASSIGNED_EPIC_ID = 0 as const;

// below data also defined in the epic panel app src/packages/software/backlog-panel/src/common/constants.js
export const DND_DROP_ZONES_ACTIVE_SPRINT = 'activeSprint' as const;
export const DND_DROP_ZONES_FUTURE_SPRINT = 'futureSprint' as const;
export const DND_DROP_ZONES_SPRINT = 'sprint' as const;
export const DND_DROP_ZONES_BOARD = 'board' as const;
export const DND_DROP_ZONES_BACKLOG = 'backlog' as const;
export const DND_DROP_ZONES_EPIC_PANEL = 'epicPanel' as const;
export const DND_DROP_ZONES_VERSION_PANEL = 'versionPanel' as const;
export const DND_DROP_ZONES_CARD_GROUP = 'cardGroup' as const;

export const DND_TARGET_BACKLOG_CARD = 'backlogCard' as const;
export const DND_TARGET_EPIC_PANEL_CARD = 'epicPanelCard' as const;
export const DND_TARGET_VERSION_PANEL_CARD = 'versionPanelCard' as const;
export const DND_TARGET_DIVIDER = 'divider' as const;

export const DND_OPERATION_MOVE_LIST_TO_LIST = 'moveListToList' as const;
export const DND_OPERATION_MOVE_INSIDE_LIST = 'moveInsideList' as const;
export const DND_OPERATION_MOVE_TO_ACTIVE_SPRINT = 'moveToActiveSprint' as const;
export const DND_OPERATION_MOVE_TO_FUTURE_SPRINT = 'moveToFutureSprint' as const;
export const DND_OPERATION_MOVE_TO_BACKLOG = 'moveToBacklog' as const;
export const DND_OPERATION_MOVE_TO_BOARD = 'moveToBoard' as const;
export const DND_OPERATION_CARD_PARENT_SET = 'cardParentSet' as const;
export const DND_OPERATION_EPIC_RANK_UPDATE = 'epicRankUpdate' as const;

export const END_ANALYTICS_BOARD_TO_BACKLOG = 'moveFromBoardToBacklog' as const;
export const END_ANALYTICS_BACKLOG_TO_BOARD = 'moveFromBacklogToBoard' as const;
export const END_ANALYTICS_ADD = 'add' as const;
export const END_ANALYTICS_REMOVE = 'remove' as const;
export const END_ANALYTICS_MOVE_BETWEEN_SPRINTS = 'moveBetweenSprints' as const;

export const CARD_ROW_HEIGHT = 40 as const;
export const COMPACT_CARD_ROW_HEIGHT = 32 as const;
export const EXTRA_CARD_ROW_HEIGHT = 30 as const;
export const INLINE_CARD_CREATE_ROW_HEIGHT = 40 as const;

export const LABELS_FIELD_SEPARATOR = ', ' as const;

export const CUSTOM_FIELD_ID_REGEX = /^customfield_([0-9]+)$/;

export const UNASSIGNED_USER: Person = {
	id: UNASSIGNED_USER_ID,
	displayName: '',
	avatarUrl: '',
};
